module.exports = __webpack_public_path__ + "img/scene_halloween_big@2x.99738729.png";